import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { useRouter } from 'next/router';
import { ReactSelectStyles } from './reactSelectStyles';
import TermsVO from '@domain/vo/terms/TermsVO';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import classnames from 'classnames/bind';
import styles from './terms.module.scss';

const cx = classnames.bind(styles);

interface ITermsProps {
  title: string;
  termsList: TermsVO[];
}

const Terms = ({ title, termsList }: ITermsProps) => {
  const { query, isReady } = useRouter();
  const [termsOption, setTermsOption] = useState<ReactSelectOption[]>([]);
  const [selectedTerms, setSelectedTerms] = useState<TermsVO | null>(null);
  const [selectedItem, setSelectedItem] = useState<ReactSelectOption | null>(null);

  const contents = selectedTerms?.contents || '';

  const [isOpen, setIsOpen] = useState(false);

  const onMenuOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onMenuClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onChangeTerms = useCallback(
    (newValue: any) => {
      const selectedItem = termsList.filter((item) => item.sn === newValue.value);
      setSelectedTerms(selectedItem[0] || null);
      setSelectedItem(newValue);
    },
    [termsList],
  );

  useEffect(() => {
    if (isReady) {
      const result: ReactSelectOption[] = termsList.map((item, idx) => {
        const temp = { value: item.sn, label: `${item.version}` };

        if (idx === 0 || Number(query.termsSn) === item.sn) {
          setSelectedItem(temp);
          setSelectedTerms(item);
        }

        return temp;
      });

      setTermsOption(result);
    }
  }, [termsList, isReady]);

  return (
    <div className={cx('wrap')}>
      <div className={cx('titleArea')}>
        <strong className={cx('title')}>{title}</strong>
        <span className={cx('recordArea')}>
          <span className={cx('recordText')}>개정이력</span>
          <Select
            instanceId={'dropDown'}
            className={cx('dropDown', { on: isOpen })}
            options={termsOption}
            styles={ReactSelectStyles}
            defaultValue={null}
            isSearchable={false}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            onChange={onChangeTerms}
            value={selectedItem}
          />
        </span>
      </div>

      <div className={cx('infoArea')}>
        <div dangerouslySetInnerHTML={{ __html: contents }} />
      </div>
    </div>
  );
};

export default Terms;
